var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoPlay = function SvgVideoPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 98,
    fill: "none",
    viewBox: "0 0 165 98"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M.359.254H164.6v96.803H.359z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M.359.254H164.6v96.803H.359z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M.359.254H164.6v96.803H.359z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M.359.254H164.6v96.803H.359z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M114.705 51.256 67.927 78.3V24.213z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-89.3926 -27.62718 30.30019 -98.04156 164.601 97.057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA12F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(66.237 12.2 82.161)scale(95.0749 108.544)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2059",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(98.26106 54.38407 -64.99 117.42383 3.02 52.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E36F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#9E36F1",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-23.945 90.2772 -68.04968 -18.0494 100.039 .254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C799",
    stopOpacity: 0
  })))));
};
export { SvgVideoPlay as ReactComponent };
export default "data:image/svg+xml;base64,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";